<template>
  <div class="container-fluid">
    <Card back>
      <template v-slot:header>
        <h3>گزارش دمو و مضور</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-3">
            <date-picker color="dimgray" v-model="filters.DateAz" clearable :editable="true" placeholder="  از تاریخ "></date-picker>
          </div>
          <div class="col-3">
            <date-picker color="dimgray" v-model="filters.DateTa" clearable :editable="true" placeholder="  تا تاریخ "></date-picker>
          </div>
          <div class="col-3" dir="rtl">
            <treeselect
              :key="usersIndex"
              name="userstree"
              :multiple="true"
              :clearable="true"
              :searchable="true"
              :open-on-click="true"
              :open-on-focus="false"
              :clear-on-select="false"
              :close-on-select="false"
              :always-open="false"
              :append-to-body="false"
              :options="Useroptions"
              v-model="filters.tblUserId"
              :normalizer="normalizer3"
              @select="Selectusers"
              @deselect="DeselctUsers"
            >
            </treeselect>
          </div>
          <div class="col-3">
            <button @click="Report" class="btn btn-success w-100">ساخت گزارش</button>
          </div>
          <div class="col-12">
            <BnpGrid :hasRowNum="true" :excel="true" :sortable="true" :key="indexTable" :propsColumn="Columns" :propsRows="rows">
              <template slot="expense" slot-scope="props">
                {{ $Comma3ragham(props.props.expense) }}
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Treeselect from '@riophae/vue-treeselect'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      normalizer3(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      filters: { tblUserId: [], DateAz: '', DateTa: '' },
      Useroptions: [],
      usersIndex: 0,
      rows: [],
      Columns: [
        { id: 2417, name: 'customerCode', visibility: true, label: 'شماره مشتری' },
        { id: 2417, name: 'codeBazaryabi', visibility: true, label: 'کد بازاریابی' },
        { id: 2417, name: 'customerName', visibility: true, label: 'نام مشتری' },
        { id: 2417, name: 'date', visibility: true, label: 'تاریخ' },
        { id: 2417, name: 'description', visibility: true, label: 'شرح حضور' },
        { id: 2417, name: 'expense', visibility: true, label: 'هزینه' },
        { id: 2417, name: 'namFam', visibility: true, label: 'نام ارائه دهنده' },
        { id: 2417, name: 'time', visibility: true, label: 'زمان' },
        { id: 2417, name: 'noehozor', visibility: true, label: 'نوع حضور در محل' },
      ],
      indexTable: 0,
    }
  },
  components: { Card, datePicker: VuePersianDatetimePicker, Treeselect, BnpGrid },
  methods: {
    Selectusers(node) {
      this.filters.tblUserId.push(node.id)
    },
    DeselctUsers(node) {
      var index = this.filters.tblUserId.indexOf(node.id)
      if (index >= 0) {
        this.filters.tblUserId.splice(index, 1)
      }
    },
    GetUsers() {
      var DataAxios = { Method: 'POST', Action: 'TblCrmCombo/GetUserDatails', ArryfildValue: null }
      this.$PostData(DataAxios).then((restult) => {
        this.Useroptions = restult
        this.usersIndex++
      })
    },
    Report() {
      var DataAxios = { Method: 'POST', Action: 'Reports/Demo', ArryfildValue: this.filters }
      this.$PostData(DataAxios).then((res) => {
        console.warn(res)
        this.rows = res.data

        this.indexTable++
      })
    },
  },
  created() {
    this.GetUsers()
  },
}
</script>

<style scoped></style>
